import React, { useContext, useState } from "react";
import { Box, TextField, Radio, RadioGroup, FormControlLabel, FormControl, Typography, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { ThemeContext } from "../../../../context/ThemeContext";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const NewReport = ({ open, handleClose, onCreateReport }) => {
    const [reportType, setReportType] = useState("html");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const { darkMode } = useContext(ThemeContext)
    const { t } = useTranslation()
    const { accountData } = useSelector((state) => state.accountSummary)
    // const creation = accountData.creationDate
    const rawCreationDate = accountData.creationDate;
    const creation = rawCreationDate ? rawCreationDate.split("T")[0] : null;

    const today = new Date();
    const parsedCreation = creation ? new Date(creation) : null;
    const parsedFrom = fromDate ? new Date(fromDate) : null;
    const parsedTo = toDate ? new Date(toDate) : null;

    const isInvalidRange = !parsedFrom || !parsedTo || parsedTo < parsedFrom || parsedTo > today || parsedFrom > today || (parsedCreation && (parsedTo < parsedCreation || parsedFrom < parsedCreation));

    const handleDialogClose = () => {
        setFromDate("");
        setToDate("");
        setReportType("html");
        handleClose();
    };
    const handleCreateReport = () => {
        onCreateReport(fromDate, toDate, reportType);
        // handleClose();
        handleDialogClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ color: "white", p: 1 }} className="bg-primary">
                <Typography id="symbol-details-modal" variant="body1" sx={{ color: darkMode ? "var(--white)" : "var(--white)" }} align="center" >{t('createNewReport')}</Typography>
            </DialogTitle>
            <DialogContent sx={{ backgroundColor: darkMode ? "#151924" : "#f5f5f5", }}>
                <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mt: 3 }}>

                    <TextField value={fromDate} onChange={(e) => setFromDate(e.target.value)} fullWidth label={t('fromDate')} type="date" InputLabelProps={{ shrink: true }} sx={{ mb: 2 }} />
                    <TextField value={toDate} onChange={(e) => setToDate(e.target.value)} fullWidth label={t('toDate')} type="date" InputLabelProps={{ shrink: true }} sx={{ mb: 2 }} />
                    <FormControl component="fieldset" fullWidth>
                        <Typography variant="body1">{t('reportType')}</Typography>
                        <RadioGroup row value={reportType} onChange={(e) => setReportType(e.target.value)}>
                            <FormControlLabel value="html" control={<Radio />} label={t('html')} />
                            <FormControlLabel value="pdf" control={<Radio />} label={t('pdf')} />
                        </RadioGroup>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions sx={{ padding: 2, backgroundColor: darkMode ? "#151924" : "#f5f5f5", }}>
                <Box sx={{ display: "flex", justifyContent: "end", width: "100%" }}>
                    <Button variant="outlined" color="primary" onClick={handleDialogClose}>{t('close')}</Button>
                    <Button variant="contained" color="primary" sx={{ ml: 2 }} onClick={handleCreateReport} disabled={isInvalidRange}>{t('createReport')}</Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default NewReport;

